module.exports = __webpack_public_path__ + "img/index-img-02.08b0be35.png";